//
import ProductModel from '@/models/Warehouse/WhProduct'

/**
 *
 */
const deleteItem = async ( wh_product_id ) => {
    //
    try {
        //
        const product  = await ProductModel.find( wh_product_id )
            , response = await product.delete()
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default deleteItem
